<div class="statusInfo px-2 d-flex flex-direction-column g-2">
  <div>
    <mat-chip-set
      aria-label="Status Pending Approval"
      class="status-chip chip-size-m"
      [ngClass]="'Pending Approval' | statusColor"
    >
      <mat-chip>Pending Approval</mat-chip>
    </mat-chip-set>
    <div>All the necessary data are ready and waiting for approval.</div>
  </div>
  <div>
    <mat-chip-set
      aria-label="Status Approved"
      class="status-chip chip-size-m"
      [ngClass]="'Approvedpipeline' | statusColor"
    >
      <mat-chip>Approved</mat-chip>
    </mat-chip-set>
    <div>All added data sources are promoted; All added connectors are ready.</div>
  </div>
  <div>
    <mat-chip-set
      aria-label="Status Needs Schema Approval"
      class="status-chip chip-size-m"
      [ngClass]="'Errors' | statusColor"
    >
      <mat-chip>Errors</mat-chip>
    </mat-chip-set>
    <div>Pipeline is implemented; Last run was unsuccessful.</div>
  </div>
  <div>
    <mat-chip-set aria-label="Status Automated" class="status-chip chip-size-m" [ngClass]="'Published' | statusColor">
      <mat-chip>Published</mat-chip>
    </mat-chip-set>
    <div>Pipeline is implemented; Last run was successful.</div>
  </div>
  <div>
    <mat-chip-set
      aria-label="Status Pending Next Run"
      class="status-chip chip-size-m"
      [ngClass]="'Pending Next Run' | statusColor"
    >
      <mat-chip>Pending Next Run</mat-chip>
    </mat-chip-set>
    <div>Last status is not meaningful, any issues from before have been cleared and it is waiting for next run.</div>
  </div>
  <div>
    <mat-chip-set aria-label="Status Queued" class="status-chip chip-size-m" [ngClass]="'queued' | statusColor">
      <mat-chip>Queued</mat-chip>
    </mat-chip-set>
    <div>Awaiting execution.</div>
  </div>
  <div>
    <mat-chip-set aria-label="Status Running" class="status-chip chip-size-m" [ngClass]="'running' | statusColor">
      <mat-chip>Running</mat-chip>
    </mat-chip-set>
    <div>Publishing is in progress.</div>
  </div>
  <div>
    <mat-chip-set aria-label="Status Pausing" class="status-chip chip-size-m" [ngClass]="'pausing' | statusColor">
      <mat-chip>Pausing</mat-chip>
    </mat-chip-set>
    <div>Pipeline pause has been requested and is being processed.</div>
  </div>
  <div>
    <mat-chip-set aria-label="Status Paused" class="status-chip chip-size-m" [ngClass]="'paused' | statusColor">
      <mat-chip>Paused</mat-chip>
    </mat-chip-set>
    <div>Execution temporarily halted, schedules are suspended.</div>
  </div>
  <div>
    <mat-chip-set aria-label="Status Resuming" class="status-chip chip-size-m" [ngClass]="'resuming' | statusColor">
      <mat-chip>Resuming</mat-chip>
    </mat-chip-set>
    <div>Pipeline resume has been requested and is being processed.</div>
  </div>
</div>
